export default "__VITE_ASSET__65271e8b__"